<div class="dash">
    <div class="dash-card no-padding">
        <div class="dash-card-header d-block" style="flex-direction: column;">
            <div class="row no-gutters">
                <div class="col-12">
                    <div style="padding-bottom: 0;">
                        <div
                            class="d-flex justify-content-between align-items-center">
                            <div>
                                <h2>Perfis de acessos</h2>
                                <p>Gerencie os perfis que definem permissões,
                                    papéis
                                    e usuários
                                    associados.</p>
                            </div>
                            <app-button (onClick)="addGroup()"
                                class="add-button"
                                *ngIf="permissionObj.canAdd && (loading || data.length > 0)">
                                <svg-icon src="assets/images/icon-add.svg"
                                    class="mr-2"></svg-icon>
                                Adicionar perfil de acessos
                            </app-button>
                        </div>
                    </div>
                </div>

                <div class="col-12 d-flex justify-content-between align-items-center mt-5 px-0"
                    *ngIf="loading || data.length > 0 || hasFilters">
                    <div class="d-flex align-items-center">
                        <button type="button" class="sort-button mr-2"
                            (click)="refreshData()" [disabled]="loading">
                            <svg-icon
                                src="assets/images/icon-renew.svg"></svg-icon>
                            <span>Atualizar</span>
                        </button>
                    </div>

                    <div class="d-flex align-items-center">
                        <app-button
                            *ngIf="hasFilters && permissionObj.canFilter && !loading"
                            [danger]="true" [outline]="true"
                            class="add-button mr-2" (onClick)="resetForm()">
                            <svg-icon src="assets/images/icon-times.svg"
                                class="filter-clear-icon p-0"></svg-icon>
                            Limpar filtros
                        </app-button>

                        <app-button [inverted]="true" class="add-button mr-2"
                            (onClick)="toggleFilterModal()" [disabled]="loading"
                            *ngIf="permissionObj.canFilter && (loading || data.length > 0 || hasFilters)">
                            <svg-icon
                                src="assets/images/icon_filter.svg"></svg-icon>
                            {{ hasFilters ? 'Editar filtros' : 'Filtrar
                            listagem' }}
                        </app-button>
                    </div>
                </div>

                <div class="col-12 mt-3 px-0"
                    *ngIf="hasFilters && appliedFilters.length > 0">
                    <div
                        class="d-flex flex-wrap align-items-center justify-content-end">
                        <app-filter-tag *ngFor="let filter of appliedFilters"
                            [label]="filter.label" [value]="filter.value">
                        </app-filter-tag>
                    </div>
                </div>
            </div>
        </div>

        <div class="dash-card-body padding-container" style="margin-top: 32px;">
            <ng-container *ngIf="loading">
                <table #table class="bordered">
                    <tbody>
                        <tr *ngFor="let number of [0,1,2,3,4,5,6]">
                            <td>
                                <ngx-skeleton-loader [theme]="{
                                            height: '16px',
                                            width: '200px',
                                        marginBottom:'0'
                                          }">
                                </ngx-skeleton-loader>
                            </td>
                            <td>
                                <ngx-skeleton-loader [theme]="{
                                    height: '16px',
                                    width: '40px',
                                    marginBottom:'0',
                                    marginLeft: 'auto'
                                  }">
                                </ngx-skeleton-loader>
                            </td>
                            <td>
                                <ngx-skeleton-loader [theme]="{
                                    height: '16px',
                                    width: '40px',
                                    marginBottom:'0',
                                    marginLeft: 'auto'
                                  }">
                                </ngx-skeleton-loader>
                            </td>
                            <td>
                                <ngx-skeleton-loader [theme]="{
                                    height: '16px',
                                    width: '150px',
                                    marginBottom:'0'
                                  }">
                                </ngx-skeleton-loader>
                            </td>
                            <td>
                                <div
                                    style="display: flex; flex-direction: column; gap: 8px;">
                                    <ngx-skeleton-loader [theme]="{
                                        height: '16px',
                                        width: '120px',
                                        marginBottom:'0'
                                      }">
                                    </ngx-skeleton-loader>
                                    <ngx-skeleton-loader [theme]="{
                                        height: '14px',
                                        width: '100px',
                                        marginBottom:'0'
                                      }">
                                    </ngx-skeleton-loader>
                                </div>
                            </td>
                            <td>
                                <ngx-skeleton-loader [theme]="{
                                    height: '24px',
                                    width: '70px',
                                    marginBottom:'0'
                                  }">
                                </ngx-skeleton-loader>
                            </td>
                            <td>
                                <div
                                    style="display: flex; gap: 16px; justify-content: flex-end;">
                                    <ngx-skeleton-loader [theme]="{
                                        height: '16px',
                                        width: '16px',
                                        marginBottom:'0',
                                        borderRadius: '0'
                                      }">
                                    </ngx-skeleton-loader>
                                    <ngx-skeleton-loader [theme]="{
                                        height: '16px',
                                        width: '16px',
                                        marginBottom:'0',
                                        borderRadius: '0'
                                      }">
                                    </ngx-skeleton-loader>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>

            <table class="bordered" *ngIf="!loading && data.length > 0">
                <thead>
                    <tr>
                        <th>Perfil</th>
                        <th>Usuários associados</th>
                        <th>Permissões associadas</th>
                        <th>Papel associado</th>
                        <th>Atualizado em</th>
                        <th>Status</th>
                        <th></th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let item of data">
                        <td>{{item.name}}</td>

                        <td>
                            {{item.associated_users}}
                        </td>

                        <td>{{item.group_permission}}</td>

                        <td>{{renderProfiles(item.users_type)}}</td>

                        <td>
                            <div class="dash-card-item-content">
                                <div class="dash-card-item-content-title">
                                    {{displayDateTime(item.updated_at).date}}
                                </div>
                                <div class="dash-card-item-content-subtitle">
                                    {{displayDateTime(item.updated_at).time}}
                                </div>
                            </div>
                        </td>

                        <td>
                            <div class="status-tag"
                                [class.-inactive]="item.status === 'Inativo' || item.status === 'inactive'">
                                {{item.status}}</div>
                        </td>

                        <td>
                            <div class="table-options"
                                *ngIf="item.created_by !== ''">
                                <app-tooltip text="Editar" [position]="'top'"
                                    *ngIf="permissionObj.canChange">
                                    <button class="dash-item-button"
                                        (click)="editGroup(item.id)">
                                        <svg-icon
                                            src="assets/images/icon-edit.svg"></svg-icon>
                                    </button>
                                </app-tooltip>
                                <app-spacer [right]="8"></app-spacer>
                                <app-tooltip
                                    [text]="(item.status === 'Ativo' || item.status === 'active') ? 'Inativar' : 'Ativar'"
                                    [position]="'top'"
                                    *ngIf="permissionObj.canInactive">
                                    <button class="dash-item-button"
                                        (click)="toggleStatus(item.id)">
                                        <svg-icon
                                            src="assets/images/icon-ban.svg"
                                            *ngIf="item.status === 'Ativo' || item.status === 'active'"></svg-icon>
                                        <svg-icon
                                            src="assets/images/icon-check-filled.svg"
                                            *ngIf="item.status === 'Inativo' || item.status === 'inactive'"></svg-icon>
                                    </button>
                                </app-tooltip>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <app-spacer [bottom]="28"></app-spacer>
            </table>

            <ng-container *ngIf="!loading && data.length === 0">
                <app-empty-content [isVisible]="true" [large]="true"
                    [title]="hasFilters ? 'Nenhum resultado encontrado' : 'Não há nenhum perfil de acesso para exibir'"
                    [description]="hasFilters ? 'Não encontramos nenhum perfil de acesso com os filtros aplicados. Tente ajustar os filtros ou limpar para ver todos os perfis.' : 'Não há perfis de acessos para serem exibidos no momento, para adicionar um novo perfil de acesso clique no botão abaixo.'"
                    icon="/assets/images/figure_3d_search.png"
                    (onClick)="addGroup()" [haveButtonIcon]="true"
                    [buttonLabel]="hasFilters ? undefined : 'Adicionar perfil de acesso'">
                </app-empty-content>
            </ng-container>
        </div>
    </div>
</div>

<div class="col-12 ml-auto mr-auto" *ngIf="data.length > 0">
    <div class="dash-card-pagination">
        <app-pagination [data]="data" [count]="count" [show]="!loading"
            [offset]="offset" (onPageChange)="changePageData($event)"
            [resultsPerPage]="results_per_page" [dashPagination]="true">
        </app-pagination>
    </div>
</div>

<app-side-filter-modal [active]="showFilterModal" [formGroup]="filterForm"
    [loading]="loading" title="Filtrar listagem"
    [disableApplyButton]="!canApplyFilters" (onClose)="toggleFilterModal()"
    (onApply)="filterData()" (onReset)="resetForm()">
    <div class="row">
        <div class="col-12">
            <app-input [group]="filterForm" controlName="name"
                placeholder="Digite" label="Perfil">
            </app-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12">
            <app-masked-input [group]="filterForm" controlName="start_date"
                mask="00/00/0000" label="Data de início"
                placeholder="dd/mm/aaaa">
            </app-masked-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12">
            <app-masked-input [group]="filterForm" controlName="end_date"
                mask="00/00/0000" label="Data final" placeholder="dd/mm/aaaa">
            </app-masked-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>
    </div>
</app-side-filter-modal>

<!-- Carbon Warning Modal para mudança de status -->
<app-carbon-warning-modal [active]="showStatusModal" [title]="getModalTitle()"
    [message]="getModalMessage()" [confirmText]="getConfirmText()"
    [cancelText]="'Não, manter como está'"
    [confirmAction]="confirmStatusChange.bind(this)"
    [cancelAction]="closeStatusModal.bind(this)" (onClose)="closeStatusModal()">
</app-carbon-warning-modal>

<app-loading-spinner [active]="showLoadingSpinner"></app-loading-spinner>